import { Card, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import HR from "../../../assets/images/hrsystem.jpg";
import Assessment from "../../../assets/images/assessment.jpg";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { useTheme } from "@mui/material/styles";

const Services = () => {
  const theme = useTheme();
  return (
    <>
      <Grid
        spacing={5}
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        sx={{ padding: 5 }}
      >
        <Grid item sm={12} xs={12}>
          <Grid container>
            <Grid item align="center" sm={6} xs={12}>
              <img src={HR} alt="hrsystem" width="90%" />
            </Grid>
            <Grid item sm={6} xs={12}>
              <Typography color="primary" variant="h2" sx={{ mb: 1 }}>
                Our Services
              </Typography>
              <Typography variant="h4" sx={{ mb: 1 }}>
                Executive Search
              </Typography>
              <Typography variant="body1" sx={{ mb: 3 }}>
                We are specialized recruitment agency which helps companies to
                fulfil their requirements regarding manpower at executive
                levels.We have expertise in placing candidates in every sector
                from fresher’s to top level management.
              </Typography>
              <Typography variant="h4" sx={{ mb: 1 }}>
                HR System
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                To help small & medium scale organizations in implementing
                following HR practices.
              </Typography>
              <Card
                variant="outlined"
                sx={{
                  mb: 2,
                  mr: 2,
                  paddingY: 1,
                  paddingX: 1.5,
                  display: "inline-block",
                  backgroundColor: theme.palette.secondary.light,
                  "&:hover": {
                    boxShadow:
                      "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                    cursor: "default",
                  },
                }}
              >
                <Typography
                  variant="subtitle"
                  color={theme.palette.primary.dark}
                >
                  Prepare Hierarchy
                </Typography>
              </Card>
              <Card
                variant="outlined"
                sx={{
                  mb: 2,
                  mr: 2,
                  paddingY: 1,
                  paddingX: 1.5,
                  display: "inline-block",
                  backgroundColor: theme.palette.secondary.light,
                  "&:hover": {
                    boxShadow:
                      "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                    cursor: "default",
                  },
                }}
              >
                <Typography
                  variant="subtitle"
                  color={theme.palette.primary.dark}
                >
                  Prepare Roles & Responsibilities
                </Typography>
              </Card>
              <Card
                variant="outlined"
                sx={{
                  mb: 2,
                  mr: 2,
                  paddingY: 1,
                  paddingX: 1.5,
                  display: "inline-block",
                  backgroundColor: theme.palette.secondary.light,
                  "&:hover": {
                    boxShadow:
                      "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                    cursor: "default",
                  },
                }}
              >
                <Typography
                  variant="subtitle"
                  color={theme.palette.primary.dark}
                >
                  Prepare KRA/KPI
                </Typography>
              </Card>
              <Card
                variant="outlined"
                sx={{
                  mb: 2,
                  mr: 2,
                  paddingY: 1,
                  paddingX: 1.5,
                  display: "inline-block",
                  backgroundColor: theme.palette.secondary.light,
                  "&:hover": {
                    boxShadow:
                      "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                    cursor: "default",
                  },
                }}
              >
                <Typography
                  variant="subtitle"
                  color={theme.palette.primary.dark}
                >
                  Prepare strong review system & Format to get maximum output
                  for employee
                </Typography>
              </Card>
              <Card
                variant="outlined"
                sx={{
                  mb: 2,
                  mr: 2,
                  paddingY: 1,
                  paddingX: 1.5,
                  display: "inline-block",
                  backgroundColor: theme.palette.secondary.light,
                  "&:hover": {
                    boxShadow:
                      "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                    cursor: "default",
                  },
                }}
              >
                <Typography
                  variant="subtitle"
                  color={theme.palette.primary.dark}
                >
                  Prepare recruitment process & formats
                </Typography>
              </Card>

              {/* ------------------------------------------------------------------------------------------------------------------------------ */}

              <Typography variant="h4" sx={{ mb: 2 }}>
                Legal Compliance
              </Typography>

              <Card
                variant="outlined"
                sx={{
                  mb: 2,
                  mr: 2,
                  paddingY: 1,
                  paddingX: 1.5,
                  display: "inline-block",
                  backgroundColor: theme.palette.primary.light,
                  "&:hover": {
                    boxShadow:
                      "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                    cursor: "default",
                  },
                }}
              >
                <Typography
                  variant="subtitle"
                  color={theme.palette.primary.dark}
                >
                  Employee Provident Fund
                </Typography>
              </Card>
              <Card
                variant="outlined"
                sx={{
                  mb: 2,
                  mr: 2,
                  paddingY: 1,
                  paddingX: 1.5,
                  display: "inline-block",
                  backgroundColor: theme.palette.primary.light,
                  "&:hover": {
                    boxShadow:
                      "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                    cursor: "default",
                  },
                }}
              >
                <Typography
                  variant="subtitle"
                  color={theme.palette.primary.dark}
                >
                  Employee State Insurance
                </Typography>
              </Card>
              <Card
                variant="outlined"
                sx={{
                  mb: 2,
                  mr: 2,
                  paddingY: 1,
                  paddingX: 1.5,
                  display: "inline-block",
                  backgroundColor: theme.palette.primary.light,
                  "&:hover": {
                    boxShadow:
                      "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                    cursor: "default",
                  },
                }}
              >
                <Typography
                  variant="subtitle"
                  color={theme.palette.primary.dark}
                >
                  Professional Tax
                </Typography>
              </Card>
            </Grid>
          </Grid>
        </Grid>

        {/* ------------------------------------------------------------------------------------------------------------- */}

        <Grid item sm={12} sx={{ display: { xs: "none", sm: "block" } }}>
          <Grid container direction="row">
            <Grid item sm={6}>
              <Typography variant="h4" sx={{ mb: 1 }}>
                Employee Assessment
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Generally companies doesn’t go for any employee assessment for
                existing employees. As it is very essential part to have the
                assessment of them to know on field problems and suggestions. We
                do one on one assessment with the employees. This service
                provided by Optima Jobs have given very effective & efficient
                results. It is useful to get following results.
              </Typography>
              <Card
                variant="outlined"
                sx={{
                  mb: 2,
                  mr: 2,
                  paddingY: 1,
                  paddingX: 1.5,
                  display: "inline-block",
                  backgroundColor: theme.palette.success.light,
                  "&:hover": {
                    boxShadow:
                      "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                    cursor: "default",
                  },
                }}
              >
                <Typography
                  variant="subtitle"
                  color={theme.palette.primary.dark}
                >
                  To measure the performance
                </Typography>
              </Card>
              <Card
                variant="outlined"
                sx={{
                  mb: 2,
                  mr: 2,
                  paddingY: 1,
                  paddingX: 1.5,
                  display: "inline-block",
                  backgroundColor: theme.palette.success.light,
                  "&:hover": {
                    boxShadow:
                      "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                    cursor: "default",
                  },
                }}
              >
                <Typography
                  variant="subtitle"
                  color={theme.palette.primary.dark}
                >
                  To know the exact problems if any
                </Typography>
              </Card>
              <Card
                variant="outlined"
                sx={{
                  mb: 2,
                  mr: 2,
                  paddingY: 1,
                  paddingX: 1.5,
                  display: "inline-block",
                  backgroundColor: theme.palette.success.light,
                  "&:hover": {
                    boxShadow:
                      "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                    cursor: "default",
                  },
                }}
              >
                <Typography
                  variant="subtitle"
                  color={theme.palette.primary.dark}
                >
                  To get suggestions & Views from Employees at the time of
                  Increment
                </Typography>
              </Card>
              <Card
                variant="outlined"
                sx={{
                  mb: 2,
                  mr: 2,
                  paddingY: 1,
                  paddingX: 1.5,
                  display: "inline-block",
                  backgroundColor: theme.palette.success.light,
                  "&:hover": {
                    boxShadow:
                      "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                    cursor: "default",
                  },
                }}
              >
                <Typography
                  variant="subtitle"
                  color={theme.palette.primary.dark}
                >
                  To help to Implement HR Systems.
                </Typography>
              </Card>

              <Typography variant="h4" sx={{ mb: 3 }}>
                Trainings
              </Typography>
              <Card
                variant="outlined"
                sx={{
                  mb: 2,
                  mr: 2,
                  paddingY: 1,
                  paddingX: 1.5,
                  display: "inline-block",
                  backgroundColor: theme.palette.grey[300],
                  "&:hover": {
                    boxShadow:
                      "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                    cursor: "default",
                  },
                }}
              >
                <Typography
                  variant="subtitle"
                  color={theme.palette.primary.dark}
                >
                  Soft skill Training
                </Typography>
              </Card>
              <Card
                variant="outlined"
                sx={{
                  mb: 2,
                  mr: 2,
                  paddingY: 1,
                  paddingX: 1.5,
                  display: "inline-block",
                  backgroundColor: theme.palette.grey[300],
                  "&:hover": {
                    boxShadow:
                      "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                    cursor: "default",
                  },
                }}
              >
                <Typography
                  variant="subtitle"
                  color={theme.palette.primary.dark}
                >
                  Motivational Training
                </Typography>
              </Card>
              <Card
                variant="outlined"
                sx={{
                  mb: 2,
                  mr: 2,
                  paddingY: 1,
                  paddingX: 1.5,
                  display: "inline-block",
                  backgroundColor: theme.palette.grey[300],
                  "&:hover": {
                    boxShadow:
                      "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                    cursor: "default",
                  },
                }}
              >
                <Typography
                  variant="subtitle"
                  color={theme.palette.primary.dark}
                >
                  Team Building Training
                </Typography>
              </Card>
              <Card
                variant="outlined"
                sx={{
                  mb: 2,
                  mr: 2,
                  paddingY: 1,
                  paddingX: 1.5,
                  display: "inline-block",
                  backgroundColor: theme.palette.grey[300],
                  "&:hover": {
                    boxShadow:
                      "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                    cursor: "default",
                  },
                }}
              >
                <Typography
                  variant="subtitle"
                  color={theme.palette.primary.dark}
                >
                  Technical Training
                </Typography>
              </Card>
            </Grid>
            <Grid item align="center" sm={6}>
              <img src={Assessment} alt="assessment" width="110%" />
            </Grid>
          </Grid>
        </Grid>

        {/* --------------------------------------------------------------------------------------------------------------------------- */}

        <Grid item xs={12} sx={{ display: { xs: "block", sm: "none" } }}>
          <Grid container direction="row">
            <Grid item align="center" xs={12}>
              <img src={Assessment} alt="assessment" width="100%" />
            </Grid>
            <Grid item sm={6}>
              <Typography color="primary" variant="h3" sx={{ mb: 2 }}>
                Employee Assessment
              </Typography>
              <Typography variant="body1" sx={{ mb: 4 }}>
                Generally companies doesn’t go for any employee assessment for
                existing employees. As it is very essential part to have the
                assessment of them to know on field problems and suggestions. We
                do one on one assessment with the employees. This service
                provided by Optima Jobs have given very effective & efficient
                results. It is useful to get following results.
              </Typography>
              <Card
                variant="outlined"
                sx={{
                  mb: 2,
                  mr: 2,
                  paddingY: 1,
                  paddingX: 1.5,
                  display: "inline-block",
                  backgroundColor: theme.palette.success.light,
                  "&:hover": {
                    boxShadow:
                      "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                    cursor: "default",
                  },
                }}
              >
                <Typography
                  variant="subtitle"
                  color={theme.palette.primary.dark}
                >
                  To measure the performance
                </Typography>
              </Card>
              <Card
                variant="outlined"
                sx={{
                  mb: 2,
                  mr: 2,
                  paddingY: 1,
                  paddingX: 1.5,
                  display: "inline-block",
                  backgroundColor: theme.palette.success.light,
                  "&:hover": {
                    boxShadow:
                      "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                    cursor: "default",
                  },
                }}
              >
                <Typography
                  variant="subtitle"
                  color={theme.palette.primary.dark}
                >
                  To know the exact problems if any
                </Typography>
              </Card>
              <Card
                variant="outlined"
                sx={{
                  mb: 2,
                  mr: 2,
                  paddingY: 1,
                  paddingX: 1.5,
                  display: "inline-block",
                  backgroundColor: theme.palette.success.light,
                  "&:hover": {
                    boxShadow:
                      "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                    cursor: "default",
                  },
                }}
              >
                <Typography
                  variant="subtitle"
                  color={theme.palette.primary.dark}
                >
                  To get suggestions & Views from Employees at the time of
                  Increment
                </Typography>
              </Card>
              <Card
                variant="outlined"
                sx={{
                  mb: 2,
                  mr: 2,
                  paddingY: 1,
                  paddingX: 1.5,
                  display: "inline-block",
                  backgroundColor: theme.palette.success.light,
                  "&:hover": {
                    boxShadow:
                      "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                    cursor: "default",
                  },
                }}
              >
                <Typography
                  variant="subtitle"
                  color={theme.palette.primary.dark}
                >
                  To help to Implement HR Systems.
                </Typography>
              </Card>
              <Typography color="primary" variant="h3" sx={{ mb: 3 }}>
                Trainings
              </Typography>
              <Card
                variant="outlined"
                sx={{
                  mb: 2,
                  mr: 2,
                  paddingY: 1,
                  paddingX: 1.5,
                  display: "inline-block",
                  backgroundColor: theme.palette.grey[300],
                  "&:hover": {
                    boxShadow:
                      "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                    cursor: "default",
                  },
                }}
              >
                <Typography
                  variant="subtitle"
                  color={theme.palette.primary.dark}
                >
                  Soft skill Training
                </Typography>
              </Card>
              <Card
                variant="outlined"
                sx={{
                  mb: 2,
                  mr: 2,
                  paddingY: 1,
                  paddingX: 1.5,
                  display: "inline-block",
                  backgroundColor: theme.palette.grey[300],
                  "&:hover": {
                    boxShadow:
                      "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                    cursor: "default",
                  },
                }}
              >
                <Typography
                  variant="subtitle"
                  color={theme.palette.primary.dark}
                >
                  Motivational Training
                </Typography>
              </Card>
              <Card
                variant="outlined"
                sx={{
                  mb: 2,
                  mr: 2,
                  paddingY: 1,
                  paddingX: 1.5,
                  display: "inline-block",
                  backgroundColor: theme.palette.grey[300],
                  "&:hover": {
                    boxShadow:
                      "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                    cursor: "default",
                  },
                }}
              >
                <Typography
                  variant="subtitle"
                  color={theme.palette.primary.dark}
                >
                  Team Building Training
                </Typography>
              </Card>
              <Card
                variant="outlined"
                sx={{
                  mb: 2,
                  mr: 2,
                  paddingY: 1,
                  paddingX: 1.5,
                  display: "inline-block",
                  backgroundColor: theme.palette.grey[300],
                  "&:hover": {
                    boxShadow:
                      "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                    cursor: "default",
                  },
                }}
              >
                <Typography
                  variant="subtitle"
                  color={theme.palette.primary.dark}
                >
                  Technical Training
                </Typography>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Services;
